import React from 'react';
import PropTypes from 'prop-types';
import { icons } from 'assets';

import Text from '../text';
import styles from './cards.module.css';

/**
 * @description This ActionCard is used to display the action card, which help user to perform a specific action
 * @param {string} title This is the title of the card
 * @param {string} subtitle This is the description of the card
 * @param {primary | secondary | tertiary} variant This is based on the variant of the color you want
 * @returns JSX.Element
 */
const ActionCard = ({ icon, title, subtitle, variant, onClick, viewable, clickable, ...sty }) => {

    return (
        <div className={`${styles.ActionCard} ${styles[variant]} ${viewable ? "" :styles.hover}`} onClick={viewable?null : clickable ? onClick: onClick} style={{...sty}}>
            {typeof icon === 'string' ? <img src={icon} alt="icon" className={styles.icon} /> : icon}
            <Text variant="sm" className={`${styles.title}`} style={{fontWeight: 600}}>{title}</Text>
            <Text variant="xs" color="secondary">{subtitle}</Text>
            {viewable  &&  <Text variant="sm" onClick={onClick} className={styles.viewable} style={{textAlign:"left"}}>
                View <img src={icons.arrowRight} alt="arrow"  style={{paddingLeft:"8px"}}/>
            </Text>}
        </div>
    )
}

ActionCard.propTypes = {
    icon: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    onClick: PropTypes.func,
    viewable: PropTypes.bool
}

export default ActionCard;